
























import { Component, Vue, Prop } from "vue-property-decorator";

@Component
class MixinUserLogo extends Vue {
  @Prop() user;

  @Prop() snapshot;

  get icon() {
    if (!this.snapshot) {
      return this.$icons.mdiAccountOutline;
    }
    const type = this.snapshot.type;
    switch (type) {
      case "deposit":
      case "withdrawal":
      case "rebate":
        return "$vuetify.icons.iconGlobal";
      case "fee":
        return this.$icons.mdiHammer;
      default:
        return "";
    }
  }

  get char() {
    const name = this.user && this.user.full_name;
    if (!name) {
      return "";
    }
    return name[0] || this.user.user_id[0];
  }
}
export default MixinUserLogo;
